export default "__VITE_ASSET__D5AEC8N___"